import { Navigate, Outlet, useLocation } from 'react-router-dom';
import useAuth from '../../hooks/useAuth';

/**
 * Route guard. Redirects unauthenticated users to /login, and users whose role is not in
 * `allowedRoles` to /.
 *
 * As a layout route:
 *   <Route element={<ProtectedRoute allowedRoles={['ADMIN']} />}>
 *     <Route path="/admin/*" element={<AdminDashboard />} />
 *   </Route>
 *
 * Or as a wrapper:
 *   <ProtectedRoute allowedRoles={['CLIENT']}><MyBookings /></ProtectedRoute>
 */
export default function ProtectedRoute({ allowedRoles, children }) {
  const { isAuthenticated, role, loading } = useAuth();
  const location = useLocation();

  if (loading) return null;

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (allowedRoles && allowedRoles.length > 0 && !allowedRoles.includes(role)) {
    return <Navigate to="/" replace />;
  }

  return children ? children : <Outlet />;
}
